<template>
  <b-modal
    id="report-preview-modal"
    :title="previewFile.name"
    size="xl"
    hide-footer
    @hidden="$emit('close')"
  >
    <div v-if="isLoading" class="preview-iframe">
      <LmComponentLoading />
    </div>
    <iframe
      v-else
      :src="previewFile.src"
      frameborder="0"
      width="100%"
      class="preview-iframe"
    ></iframe>
  </b-modal>
</template>

<script>

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      apiUrl: process.env.VUE_APP_API_URL,
      previewFile: {
        name: '',
        src: ''
      }
    }
  },
  methods: {
    async onPreview () {
      try {
        this.isLoading = true
        await this.$bvModal.show('report-preview-modal')
        this.previewFile = {
          name: 'Reportes',
          src: `${this.apiUrl}reports/render/${this.id}`
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.preview-iframe{
  min-height: 80vh;
}
</style>
